const NotamachineRemixesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/4jEUhtplLJ4nqCgEtgvqWd?si=1453b24701bf44cd" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>isid or - all the sounds (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/5oQMbDorntRCD9Y0wYXuAp?si=d983ef85ebd241e0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Jedwill - placebo effect (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/46GNeZiuPE67iFEgYE68iW?si=241f3219f56448c0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>internetboy - skin care (notamachine remix)</strong><br/>
              </p>
            </a>
          </div> 

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/11UPjUSepAMxQVN7UkPOSV?si=4e72e9d8b8d34ed1" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>blissom - so far (notamachine remix)</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/2SMLAFmAMBZljHgI55TBYp?si=b59791853f3b48d0" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>Button Maker, billy ! & 1Booth - ENOUGH! (notamachine remix)</strong><br/>
              </p>
            </a>
          </div>  

        <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/notamachineprod/skinny-love-notamachine-remix" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-ezHsyWu4zSvmpsBR-M47n8g-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
              <strong>Bon Iver - Skinny Love</strong><br/>
              (notamachine remix)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/7qSgp4mnLc1XlRxMl0aEVt?si=dd57166cb45d4be2" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b273ddc7c82c96ddddf69728761a" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>mothgirl - body carving</strong><br/>
                (notamachine remix)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://open.spotify.com/track/2eE162PF1piUQXAkrjAo30?si=f91f892b70114a3e" target="_blank" rel="noopener noreferrer">    
              <img src="https://i.scdn.co/image/ab67616d0000b2732e3282c641ee817ec953de42" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Button Maker - PENALTY GAME</strong><br/>
                (notamachine remix)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default NotamachineRemixesStatic;